<template>
	<modal :show.sync="syncModal" footerClasses="d-none">
		<FormReportName>
			<template #return>
				<base-button
					@click.stop="syncModal = false"
					:disabled="formProcessing"
					type="white"
					size="md"
					class="px-0 bg-transparent font-weight-normal shadow-none"
					>Cancel</base-button
				>
			</template>
		</FormReportName>

		<template #footer>
			<div class="sr-only"></div>
		</template>
	</modal>
</template>

<script>
import FormReportName from "@components/FormReportName";

export default {
	name: "report-name-modal",
	components: {
		FormReportName,
	},
	data() {
		return {
			syncModal: false,
			formProcessing: false,
		};
	},
	mounted() {
		this.$bus.trackEvent("toggle-modal", (payload) => {
			if ("report-name" === payload.key) this.syncModal = payload.active;
		});

		this.$bus.trackEvent("report-name-form-processing", (payload) => {
			this.syncModal = payload;
			this.formProcessing = payload;
		});
	},
};
</script>
